export default "__VITE_ASSET__DBQgA9vI__"